import { User } from "../../core/auth";
import { BareActionContext } from "vuex-typex";
import { storeBuilder, RootState } from "../RootState";
import Auth from "../../core/auth";

// Local Storage Key to store the user
const LS_USER_KEY = "roon-user";

export class AuthState {
  currentUser: User | null = null;
  isLoggingIn = false;
}

const b = storeBuilder.module<AuthState>("auth", new AuthState());

// getters
const currentUser = b.read((state) => state.currentUser, "currentUser");
const isAuthenticated = b.read(
  (state) => !!state.currentUser,
  "isAuthenticated"
);
const isLoggingIn = b.read((state) => state.isLoggingIn, "isLoggingIn");

export const getters = {
  get currentUser() {
    return currentUser();
  },
  get isAuthenticated() {
    return isAuthenticated();
  },
  get isLoggingIn() {
    return isLoggingIn();
  },
};

// mutations
function setUser(state: AuthState, user: User) {
  state.currentUser = user;

  try {
    localStorage.setItem(LS_USER_KEY, JSON.stringify(user));
  } catch (err) {
    console.warn(err);
  }
}

function clearUser(state: AuthState) {
  state.currentUser = null;

  try {
    localStorage.removeItem(LS_USER_KEY);
  } catch (err) {
    console.warn(err);
  }
}

function loadUserFromLS(state: AuthState) {
  try {
    const user = localStorage.getItem(LS_USER_KEY);
    if (!user) {
      return;
    }

    const parsedUser = JSON.parse(user);

    state.currentUser = parsedUser as User;
  } catch (err) {
    console.warn(err);
  }
}

function startLogin(state: AuthState) {
  state.isLoggingIn = true;
}

function endLogin(state: AuthState) {
  state.isLoggingIn = false;
}

export const mutations = {
  setUser: b.commit(setUser),
  clearUser: b.commit(clearUser),
  loadUserFromLS: b.commit(loadUserFromLS),
  startLogin: b.commit(startLogin),
  endLogin: b.commit(endLogin),
};

// actions
type ActionContext = BareActionContext<AuthState, RootState>;

async function login(
  context: ActionContext,
  { email, password }: { email: string; password: string }
) {
  try {
    mutations.startLogin();
    const user = await Auth.login(email, password);
    mutations.setUser(user);
  } finally {
    mutations.endLogin();
  }
}

async function logout() {
  await Auth.logout();
  mutations.clearUser();
}

export const actions = {
  login: b.dispatch(login),
  logout: b.dispatch(logout),
};
